var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUiLinedShow124(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#141414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.79 11.407C21.576 9.9 17.216 5 12 5S2.424 9.9 1.21 11.407a.942.942 0 000 1.187C2.424 14.1 6.784 19 12 19s9.576-4.9 10.79-6.407a.942.942 0 000-1.186zM12 18c-4.895 0-9.2-5.026-10.01-5.967C2.8 11.026 7.105 6 12 6c4.843 0 9.106 4.919 9.983 6-.877 1.081-5.14 6-9.983 6zm4-6a4 4 0 11-6-3.445V12l3.64-3.64A3.992 3.992 0 0116 12z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiLinedShow124);
export default __webpack_public_path__ + "static/media/ui-lined-show-1-24.d633675c.svg";
export { ForwardRef as ReactComponent };